import React, { useState } from 'react';
import FeedbackGrid from './FeedbackGrid';
import HeaderFilter from './HeaderFilter';
import { Paper } from '@material-ui/core';
import Filters from './Filters';

const FeedbackSetupMaster = ({ feedbackName, value }) => {
  const [SelectedID, setSelectedID] = useState('');
  const [CourseID, setCourseID] = useState('');
  const [SessionData, setSessionData] = useState('');

  return (
    <>
      <Paper>
        {value === 0 && (
          <Filters
            term={true}
            setSelectedID={setSelectedID}
            setCourseID={setCourseID}
            CourseVersion={true}
            sessionFeedback={true}
            courseoff={true}
            value={value}
            setSessionData={setSessionData}
          />
        )}
        {value === 1 && (
          <Filters
            term={true}
            setSelectedID={setSelectedID}
            setCourseID={setCourseID}
            CourseVersion={true}
            value={value}
            setSessionData={setSessionData}
          />
        )}
      </Paper>
      <FeedbackGrid
        SelectedID={SelectedID}
        value={value}
        CourseID={CourseID}
        SessionData={SessionData}
      />
    </>
  );
};

export default FeedbackSetupMaster;
